module.exports = __webpack_public_path__ + "img/19b033_a27eb5902b7648d3acd54f27fdd1bf03~mv2.45695101.gif";